import useFetch from 'utils/hooks/useFetch'
import { ApiDeletePayment, ApiGetPayment, ApiGetPaymentByBookingId, ApiGetPaymentList, ApiInsertPayment, ApiUpdatePayment } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function PaymentService() {
    const { showFail } = useModal()

    const { fetch: apiInsertPayment } = useFetch(ApiInsertPayment)
    const { fetch: apiUpdatePayment } = useFetch(ApiUpdatePayment)
    const { fetch: apiDeletePayment } = useFetch(ApiDeletePayment)
    const { fetch: apiGetPaymentById } = useFetch(ApiGetPayment)
    const { fetch: apiGetPaymentList } = useFetch(ApiGetPaymentList)
    const { fetch: apiGetPaymentByBookingId } = useFetch(ApiGetPaymentByBookingId)
 
    const fetchCreatePayment = async (paymentDate, paymentType, bookingId, paymentPeriodeMonth, paymentPeriodeYear, amount, remark) => {
        const res = await apiInsertPayment({
            data: {
                paymentDate,
                paymentType,
                bookingId,
                paymentPeriodeMonth,
                paymentPeriodeYear,
                amount,
                remark,
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdatePayment = async (paymentId, paymentDate, paymentType, bookingId, paymentPeriodeMonth, paymentPeriodeYear, amount, remark) => {
        const res = await apiUpdatePayment({
            data: {
                paymentId,
                paymentDate,
                paymentType,
                bookingId,
                paymentPeriodeMonth,
                paymentPeriodeYear,
                amount,
                remark,
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeletePayment = async (paymentId, status) => {
        const res = await apiDeletePayment({
            data: {
                paymentId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchPaymentById = async (paymentId) => {
        const res = await apiGetPaymentById({
            data: {
                paymentId,
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchPaymentList = async (tenantName, paymentPeriodeMonth, paymentPeriodeYear, paymentType, status, pageSize, pageIndex) => {
        const res = await apiGetPaymentList({
            data: {
                tenantName,
                paymentPeriodeMonth,
                paymentPeriodeYear,
                paymentType,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchPaymentByBookingId = async (bookingId, pageSize, pageIndex) => {
        const res = await apiGetPaymentByBookingId({
            data: {
                bookingId,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCreatePayment,
        fetchUpdatePayment,
        fetchDeletePayment,
        fetchPaymentById,
        fetchPaymentList,
        fetchPaymentByBookingId,
    }
}